module.exports = __webpack_public_path__ + "index_pc/img/b2.96bf23f8.png";